"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import useSWR from 'swr';
import { useMembrane } from '../../contexts/use-integration-app.mjs';

function useConnectorSpec(integrationIdOrKey) {
  const integrationApp = useMembrane();
  const { data, isLoading, error } = useSWR(
    integrationIdOrKey ? `/integrations/${integrationIdOrKey}/connector-spec` : void 0,
    () => integrationApp.integration(integrationIdOrKey).getConnectorSpec()
  );
  return { data, loading: isLoading, error };
}

export { useConnectorSpec };
